// dataService.js
import api from "../../../utils/ApiConfig";

// ✅ Récupérer toutes les commandes des fournisseurs
const fetchAllFournisseurCommandes = async (nbr, termSearch, nbPage, status, livreurId, deliveryDate, enRetard, clientType, manutentionAConfirmer, manutentionAValider, masquerPaiementsEchoues = true) => {
  try {
    const params = {
      page: nbr,
      search: termSearch,
      nbpage: nbPage,
      status: status,
      livreur_id: livreurId,
      delivery_date: deliveryDate,
      en_retard: enRetard ? 'true' : undefined,
      client_type: clientType,
      manutention_a_confirmer: manutentionAConfirmer ? 'true' : undefined,
      // Chiffrée par un livreur et pas encore relue : le montant part en
      // facturation qu'on l'ait relu ou non.
      manutention_a_valider: manutentionAValider ? 'true' : undefined,
      // Masque les commandes dont le paiement carte a echoue ou a ete annule.
      // Coche par defaut dans l'ecran : sinon elles ressemblaient a des
      // commandes a livrer. Les paiements simplement en attente restent visibles.
      masquer_paiements_echoues: masquerPaiementsEchoues ? '1' : undefined,
    };

    const filteredParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== "" && value !== null)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const response = await api.get(`/fo/ShowAllCommandeFournisseur?${filteredParams}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

// ✅ Récupérer toutes les commandes pour le calendrier (sans pagination)
const fetchAllFournisseurCommandesForCalendar = async (termSearch, status, livreurId, deliveryDate, enRetard, clientType, masquerPaiementsEchoues = true) => {
  try {
    const params = {
      search: termSearch,
      status: status,
      livreur_id: livreurId,
      delivery_date: deliveryDate,
      en_retard: enRetard ? 'true' : undefined,
      client_type: clientType,
      // Masque les commandes dont le paiement carte a echoue ou a ete annule.
      // Coche par defaut dans l'ecran : sinon elles ressemblaient a des
      // commandes a livrer. Les paiements simplement en attente restent visibles.
      masquer_paiements_echoues: masquerPaiementsEchoues ? '1' : undefined,
    };

    const filteredParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== "" && value !== null)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const response = await api.get(`/fo/ShowAllCommandeFournisseurForCalendar?${filteredParams}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching calendar data:", error);
    throw error;
  }
};

// ✅ Récupérer toutes les commandes pour le kanban (sans pagination)
// limitDelivered: si défini, limite le nombre de commandes livrées retournées (ex: 20)
const fetchAllFournisseurCommandesForKanban = async (termSearch, status, livreurId, deliveryDate, enRetard, clientType, limitDelivered = null, masquerPaiementsEchoues = true) => {
  try {
    const params = {
      search: termSearch,
      status: status,
      livreur_id: livreurId,
      delivery_date: deliveryDate,
      en_retard: enRetard ? 'true' : undefined,
      client_type: clientType,
      limit_delivered: limitDelivered,
      // Masque les commandes dont le paiement carte a echoue ou a ete annule.
      // Coche par defaut dans l'ecran : sinon elles ressemblaient a des
      // commandes a livrer. Les paiements simplement en attente restent visibles.
      masquer_paiements_echoues: masquerPaiementsEchoues ? '1' : undefined,
    };

    const filteredParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== "" && value !== null)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const response = await api.get(`/fo/ShowAllCommandeFournisseurForKanban?${filteredParams}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching kanban data:", error);
    throw error;
  }
};

// ✅ Fonction pour récupérer les demandes depuis Laravel
const fetchLaravelDemandes = async () => {
  try {
    const response = await api.get(`/commandes/demandes`); // Assure-toi que cet endpoint existe dans Laravel
    return response.data?.data || [];
  } catch (error) {
    console.error("Erreur lors de la récupération des demandes Laravel :", error);
    return [];
  }
};

// ✅ Récupérer les commandes d’un fournisseur (à compléter si utilisé)
const fetchFournisseurCommandes = async (nbr, termSearch) => {
  try {
    const response = await api.get(`/...?page=${nbr}${termSearch}`);
  } catch (error) {
    console.error("Error fetching Orders Fournisseur data:", error);
    throw error;
  }
};

// ✅ Ajouter une commande fournisseur
const CreateFournisseurCommande = async (orderFournisseur) => {
  try {
    const response = await api.post(`/fo/addCommandeFournisseur`, orderFournisseur);
    return response;
  } catch (error) {
    console.error("Error saving Order Fournisseur data:", error);
    throw error;
  }
};

// ✅ Mettre à jour une commande fournisseur
const updateFournisseurCommande = async (orderId, orderData) => {
  try {
    const response = await api.post(`/fo/updateCommandeFournisseur/${orderId}`, orderData);
    return response;
  } catch (error) {
    console.error("Error updating Order Fournisseur data:", error);
    throw error;
  }
};

// ✅ Récupérer tous les livreurs
const FetchAllLivreur = async () => {
  try {
    const response = await api.get(`/bo/getAllLivreur`);
    return response;
  } catch (error) {
    console.error("Error to get list livreur data:", error);
    throw error;
  }
};

// ✅ Récupérer tous les fournisseurs
const FetchListFournisseur = async () => {
  try {
    const response = await api.get(`/bo/getAllFournisseur`);
    return response;
  } catch (error) {
    console.error("Error to get list fournisseur data:", error);
    throw error;
  }
};

// ✅ Récupérer tous les particuliers
const FetchListParticuliers = async () => {
  try {
    const response = await api.get(`/bo/getAllParticuliers`);
    return response;
  } catch (error) {
    console.error("Error to get list particuliers data:", error);
    throw error;
  }
};

// ✅ Récupérer toutes les entreprises
const FetchListEntreprises = async () => {
  try {
    const response = await api.get(`/bo/getAllEntreprises`);
    return response;
  } catch (error) {
    console.error("Error to get list entreprises data:", error);
    throw error;
  }
};

// ✅ Récupérer une commande fournisseur par ID
const GetOneCommandeById = async (idcommande) => {
  try {
    const response = await api.get(`/fo/ShowOneCommandeFournisseur/${idcommande}`);
    return response.data;
  } catch (error) {
    console.error("Error to get Order fournisseur data:", error);
    throw error;
  }
};

// ✅ Récupérer toutes les dates de livraison disponibles
const fetchAvailableDeliveryDates = async () => {
  try {
    const response = await api.get(`/fo/getAvailableDeliveryDates`);
    return response.data;
  } catch (error) {
    console.error("Error fetching available delivery dates:", error);
    throw error;
  }
};

// ✅ Récupérer la disponibilité des livreurs pour une date donnée
const fetchLivreurDisponibilite = async (dateLivraison) => {
  try {
    const response = await api.get(`/livreurs/disponibilite`, {
      params: {
        date: dateLivraison
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching livreur disponibilite:", error);
    throw error;
  }
};

// ✅ Récupérer le feedback pickup/livraison ("tout s'est bien passé ?") d'une commande
const fetchCommandeFeedback = async (commandeId) => {
  try {
    const response = await api.get(`/fo/commande/${commandeId}/feedback`);
    return response.data;
  } catch (error) {
    console.error("Error fetching commande feedback:", error);
    throw error;
  }
};

// ✅ Récupérer les images POD (Proof of Delivery) d'une commande
const fetchPODImages = async (commandeId) => {
  try {
    const response = await api.get(`/fo/commande/${commandeId}/pod-images`);
    return response.data;
  } catch (error) {
    console.error("Error fetching POD images:", error);
    throw error;
  }
};

// ✅ Ajouter une image POD
const uploadPODImage = async (commandeId, imageFile) => {
  try {
    const formData = new FormData();
    // Le backend attend un tableau 'images', on utilise images[0] pour le premier élément
    formData.append('images[0]', imageFile);
    const response = await api.post(`/fo/commande/${commandeId}/pod-images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading POD image:", error);
    throw error;
  }
};

// ✅ Supprimer une image POD
const deletePODImage = async (commandeId, imageId) => {
  try {
    const response = await api.delete(`/fo/pod-images/${imageId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting POD image:", error);
    throw error;
  }
};

// ✅ Générer un avoir et rembourser via Stripe
const genererAvoir = async (commandeId, motif) => {
  try {
    const response = await api.post(`/bo/commandes-fournisseur/${commandeId}/generer-avoir`, { motif });
    return response.data;
  } catch (error) {
    console.error("Error generating avoir:", error);
    throw error;
  }
};

/**
 * Avoir à montant libre sur une commande facturée.
 *
 * Ne rembourse rien : il produit le document comptable, le remboursement
 * éventuel reste une action bancaire séparée. C'est ce qui le distingue de
 * genererAvoir(), qui rembourse la totalité via Stripe et annule la commande.
 */
const genererAvoirPartiel = async (commandeId, montantHt, motif) => {
  const response = await api.post(`/bo/commandes-fournisseur/${commandeId}/avoir-partiel`, {
    montant_ht: montantHt,
    motif,
  });
  return response.data;
};

// ✅ Confirmer une manutention laissée en "à confirmer".
// Deux modes exclusifs : soit les réponses du barème (distance, obstacles, etage,
// ascenseur, poids_colis), soit un montant négocié (total_ht) pour le cas
// exceptionnel que le barème ne tarife pas.
const confirmerManutention = async (commandeId, payload) => {
  try {
    const response = await api.patch(`/bo/commandes-fournisseur/${commandeId}/manutention`, payload);
    return response.data;
  } catch (error) {
    console.error("Error confirming manutention:", error);
    throw error;
  }
};

// Les adresses d'enlèvement d'un client, pour l'ops qui passe une commande à sa
// place. Elles arrivent AVEC leurs coordonnées, donc en choisir une garantit la
// latitude et la longitude sans aucun géocodage — c'est le chemin le plus sûr
// des trois. La réponse porte aussi les suppléments de la grille de ce client.
const fetchAdressesRamassageClient = async (clientId) => {
  try {
    const response = await api.get(`/bo/clients/${clientId}/adresses-ramassage`);
    return response.data;
  } catch (error) {
    console.error("Erreur chargement adresses de ramassage du client:", error);
    // Null et non une exception : l'écran reste utilisable sans les suggestions,
    // l'ops saisit alors l'adresse à la main comme avant.
    return null;
  }
};

// Temps passé chez le client d'après le GPS du livreur, comparé au temps prévu
// (poids + manutention). Route admin à part : jamais dans la réponse /fo.
const fetchTempsSurPlace = async (idCommande) => {
  const response = await api.get(`/bo/commandes/${idCommande}/temps-sur-place`);
  return response.data;
};

// ✅ Exportation des fonctions
export {
  fetchTempsSurPlace,
  fetchFournisseurCommandes,
  CreateFournisseurCommande,
  updateFournisseurCommande,
  FetchAllLivreur,
  FetchListFournisseur,
  FetchListParticuliers,
  FetchListEntreprises,
  fetchAllFournisseurCommandes,
  fetchAllFournisseurCommandesForCalendar,
  fetchAllFournisseurCommandesForKanban,
  GetOneCommandeById,
  fetchLaravelDemandes,
  fetchAvailableDeliveryDates,
  fetchLivreurDisponibilite,
  fetchPODImages,
  uploadPODImage,
  deletePODImage,
  fetchCommandeFeedback,
  genererAvoir,
  genererAvoirPartiel,
  confirmerManutention,
  fetchAdressesRamassageClient
};
